import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import productData from "../data/products.json"; // Make sure this path is correct
import Productlistcard from "../components/Productlistcard";
import { Helmet } from "react-helmet";
import ImportantInfoAccordion from "../components/AccordionSection";
import ProductDetailedCard from "../components/ProductDetailedCard";
import FaqPage from "./FaqPage";
import Productslideshow from "../components/Productslideshow";


const ProductDetail = () => {
  const { str } = useParams();
  const [product, setProduct] = useState(null);

  const [imageKeys, setImageKeys] = useState([]);

  useEffect(() => {
    const foundProduct = productData.products.find(
      (p) => p.str.toLowerCase() === str.toLowerCase()
    );

    setProduct(foundProduct);

    if (foundProduct) {
      const keys = ['image', 'image1', 'image2' ,'image3', 'image4', 'image5' , 'image6', 'image7']
        .filter((key) => foundProduct[key]); // only include available keys

      setImageKeys(keys);
    }
  }, [str]);

  const images = imageKeys
    .filter((key) => product[key])
    .map((key) => ({
      src: `/${product[key]}`,
      thumb: `/${product[key]}`, // using same image for thumbnail
      alt: product.name,
    }));


  if (!product) {
    return (
      <div className="text-red-600 text-center py-16 font-semibold text-lg">
        Product not found.
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <link rel="preload" as="image" href={`/${product.image}`} />
      </Helmet>
      
    <section className="py-2 lg:py-4 text-black">
      <div className="container  mx-auto">
        <ProductDetailedCard product={product} images={images} />
        <ImportantInfoAccordion product={product}/>
        
        <div>
          {product.coverimage1 && (
            <img
              alt={product.name}
              aria-hidden="true"
              className="w-full h-auto object-cover object-center mt-10"
              src={`/${product.coverimage1}`}
            />
          )}
          {product.coverimage2 && (
            <img
              alt={product.name}
              aria-hidden="true"
              className="w-full h-auto object-cover object-center"
              src={`/${product.coverimage2}`}
            />
          )}
          {product.coverimage3 && (
            <img
              alt={product.name}
              aria-hidden="true"
              className="w-full h-auto object-cover object-center"
              src={`/${product.coverimage3}`}
            />
          )}
          {product.coverimage4 && (
            <img
              alt={product.name}
              aria-hidden="true"
              className="w-full h-auto object-cover object-center border-2"
              src={`/${product.coverimage4}`}
            />
          )}
          {product.coverimage5 && (
            <img
              alt={product.name}
              aria-hidden="true"
              className="w-full h-auto object-cover object-center border-2"
              src={`/${product.coverimage5}`}
            />
          )}
        </div>
        
        <section className="text-black">
          <div className="container  mt-10">
            <h2 className="text-2xl md:text-4xl text-center font-bold">Our Other Products</h2>
            <Productlistcard/>
          </div>
          <div className="container mx-auto mt-2">
            <h2 className="text-2xl md:text-2xl font-bold mb-4 text-center uppercase">Meet our new launch</h2>
            <Productslideshow showproduct={'sun-freeze-sunscreen-spf-50-pa++++'}/>
          </div>
        </section>
        <FaqPage/>
      </div>
    </section>
    </>
  );
};

export default ProductDetail;
